<template>
  <div>
    <ContentLoader v-if="isSupplierDataLoaded" />
    <div class="p-3" v-else>
      <div class="position-fixed bg-primary p-3" style="z-index: 5">
        <div class="d-flex fex-row flex-sm-column btns">
          <BookmarkButton
            :product-id="product.id"
            class="mr-3 mr-md-0 mb-md-3"
            :btn-classes="['btn-block', 'btn-sm', 'btn-outline-light']"
          />
          <ContactButton
            class="mr-3 mr-md-0"
            v-if="product.supplier"
            :product-id="product.id"
            :id="product.supplier_id"
            :has-message="hasMessage"
            :btn-classes="['btn-block', 'btn-sm', 'btn-outline-light']"
          />
          <b-button
            class="d-md-none btn-block btn-sm btn-outline-light bg-primary"
            v-b-toggle.supplier-details
          >
            <i class="fas fa-user" />
          </b-button>
        </div>
      </div>
      <div class="mt-5 pt-3 mt-md-0 pt-md-0">
        <div class="container" style="padding: 0px !important">
          <div class="row">
            <div class="col-12 col-md-8">
              <div>
                <carousel
                  :per-page="1"
                  :center-mode="true"
                  :pagination-position="'bottom-overlay'"
                  :pagination-color="'#000'"
                  :pagination-active-color="'#fd7e14'"
                >
                  <slide
                    data-index="0"
                    data-name="MySlideName"
                    v-for="(img, index) in images"
                    :key="index"
                  >
                    <div class="text-center">
                      <div class="position-relative">
                        <h3
                          class="text-white p-2 position-absolute w-100"
                          style="background: #0000004f"
                        >
                          {{ img.title || 'No Title' }}
                        </h3>
                        <img
                          :src="img.url || NoImageAvailable"
                          :alt="img.title"
                          @error="imgError"
                          @click="zoomImage(img.url)"
                          class="product-image"
                        />
                        <p class="py-3">
                          {{ img.description || 'No Description' }}
                        </p>
                      </div>
                    </div>
                  </slide>
                </carousel>
                <div class="w-100 mt-2" style="z-index: 5; top: 60px">
                  <div class="container w-100 py-0">
                    <div class="row">
                      <div class="col-12">
                        <div class="row bg-primary p-3">
                          <div title="Viewed" class="pr-3">
                            <i class="fa fa-eye" />
                            {{ product.threshhold }}
                          </div>
                          <div title="Sold" class="pr-3">
                            <i class="fas fa-truck" />
                            {{ product.quantity }}
                          </div>
                          <div
                            :title="`Will be ready in ${
                              product.ready_time
                            } ${translate('tooltips.days')}`"
                          >
                            <i class="fas fa-calendar-check" />
                            {{ product.completion_days }}
                            {{ translate('tooltips.days') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="my-3">
                  <h1>{{ product.name }}</h1>
                  <hr class="custom-hr" />

                  <div>
                    <h5>Description</h5>
                    <p v-html="product.description"></p>
                  </div>
                  <div>
                    <h5>Region</h5>
                    <p>
                      {{ product.region.value ? product.region.value : 'N/A' }}
                    </p>
                  </div>
                  <div>
                    <h5>Community</h5>
                    <p>
                      {{
                        product.community.value
                          ? product.community.value
                          : 'N/A'
                      }}
                    </p>
                  </div>
                  <div>
                    <h5>Specification</h5>
                    <p>
                      {{
                        product.specifications.specifications
                          ? product.specifications.specifications
                          : 'N/A'
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 d-none d-md-inline-block">
              <div class="shadow-sm supplier-box card" v-if="product.supplier">
                <router-link
                  :to="'/suppliers/' + product.supplier.id"
                  class="supplier-img cursor-pointer"
                  @click="openSupplier"
                >
                  <img
                    :src="product.supplier.image"
                    alt="supplier-image"
                    class="w-100"
                /></router-link>
                <SupplierInfo
                  :supplier="product.supplier"
                  :icon-color="'#ff9923'"
                  :text-color="'#3b3f41'"
                  :show-profile-pic="false"
                />
              </div>
            </div>
          </div>
          <ImageMaxZoom />
        </div>
      </div>
      <br />
      <div class="container p-0">
        <template v-if="product.related_products">
          <h2>{{ translate('products.related_products') }}</h2>
          <hr class="custom-hr" />
          <div class="d-flex justify-content-between flex-wrap">
            <ProductBoxSm
              v-for="item in relatedProducts"
              :key="item.id"
              :product="item"
              @click="
                $router.push({ name: 'product', params: { id: item.id } })
              "
            />
            <span v-if="!relatedProducts.length">{{ 'No data found!' }}</span>
          </div>
        </template>
      </div>
      <b-sidebar id="supplier-details" title="Supplier Details" shadow>
        <div class="px-3 py-2">
          <router-link
            :to="'/suppliers/' + product.supplier.id"
            class="supplier-img cursor-pointer"
            @click="openSupplier"
          >
            <img
              :src="product.supplier.image"
              alt="supplier-image"
              class="w-100"
          /></router-link>
          <SupplierInfo
            :supplier="product.supplier"
            :icon-color="'#ff9923'"
            :text-color="'#3b3f41'"
            :show-profile-pic="false"
          />
          <br />
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import {
  getProduct,
  getSupplierDetails,
  getRelatedProducts
} from '../api/services/product'
import BookmarkButton from '@/components/product/BookmarkButton'
import ContactButton from '@/components/product/ContactButton'
import ProductBoxSm from '@/components/product/ProductBoxSm'
import SupplierInfo from '@/components/sharable/SupplierInfo'
import optional from 'lodash.get'
import NoImageAvailable from '@/assets/images/no-image.png'
import ImageNotFound from '@/assets/images/image-not-found.png'
import ImageMaxZoom from '@/components/sharable/modals/ImageMaxZoom'
import _ from 'lodash'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'Product',
  components: {
    ProductBoxSm,
    ContactButton,
    BookmarkButton,
    SupplierInfo,
    ImageMaxZoom,
    Carousel,
    Slide
  },
  props: {
    id: {
      required: true,
      type: String | Number
    }
  },
  data() {
    return {
      product: { image_details: [] },
      supplierDetails: {},
      relatedProducts: [],
      showSupplier: false,
      isSupplierDataLoaded: false,
      NoImageAvailable,
      successMessage: '',
      hasMessage: false
    }
  },
  methods: {
    openSupplier() {
      if (!this.showSupplier) {
        this.showSupplier = true
      } else {
        this.$router.push({
          name: 'supplier',
          params: { id: this.product.supplier.id }
        })
      }
    },
    async getSupplierDetails() {
      if (this.product && this.product.supplier) {
        const dataRes = await getSupplierDetails(this.product.supplier.uuid)
        if (dataRes) {
          this.supplierDetails = dataRes.supplierDetails
        }
      }
    },
    async getProduct() {
      this.isSupplierDataLoaded = true
      let { data } = await getProduct(this.id)
      console.log(data, 'data')
      this.product = data
      this.isSupplierDataLoaded = false
      this.hasMessage = !_.isEmpty(data.orders) ? true : false
    },
    async getRelatedProducts() {
      let { data } = await getRelatedProducts(
        this.product.id,
        this.product.service
      )
      this.relatedProducts = data
    },
    imgError(event) {
      event.target.src = ImageNotFound
    },
    zoomImage(image) {
      if (image) {
        this.$eventBus.$emit('zoom-image', image)
      }
    }
  },
  computed: {
    images() {
      let images = []
      let productImage = ['image']
      ;[...Array(5).keys()].forEach((index) => {
        if (index >= 2) {
          productImage.push(`image${index}`)
        }
      })
      productImage.forEach((value, index) => {
        images.push({
          url: this.product[value],
          title: optional(this.product.image_details[index], `title`, ''),
          description: optional(
            this.product.image_details[index],
            `description`,
            ''
          )
        })
      })
      return images
    }
  },
  async mounted() {
    localStorage.removeItem('login-redirect')
    await this.getProduct()
    await this.getSupplierDetails()
    await this.getRelatedProducts()
    if (JSON.parse(localStorage.getItem('open-contact-form'))) {
      this.$bvModal.show('contact-supplier-form')
      localStorage.removeItem('open-contact-form')
    }
  }
}
</script>

<style scoped lang="scss">
.product-image {
  height: 400px;
  width: 100%;
  object-fit: cover;
}

.custom-hr {
  border: none;
  height: 4px;
  background: #ff9a21;
  width: 200px;
  margin-bottom: 40px;
  margin-left: 0px;
}
// .cursor-pointer {
//   display: none;
// }
// .top-bar {
//   position: fixed;
//   z-index: 1;
//   left: 2%;
//   margin-top: -10px;

//   .btns {
//     width: 100%;
//   }

//   .bar-items {
//     background-color: #ff9a22;
//     color: #fff;

//     .text-muted {
//       color: #fff;
//     }
//   }
// }

// .main {
//   .product-info {
//     padding: 0 15px 15px 15px;
//     margin-top: -15px;
//     .img-wrapper {
//       height: 250px !important;
//       width: 100% !important;
//       img {
//         height: 250px !important;
//         width: 100% !important;
//         object-fit: cover;
//       }
//     }
//   }
// }

// .supplier-container {
//   position: fixed;
//   top: 70px;
//   left: 50%;
//   transform: translateX(-50%);
//   z-index: 1;

//   .supplier-box {
//     display: flex;
//     align-items: center;
//     flex-direction: column;
//     padding: 0 0 3px 3px;
//     position: fixed;
//     right: 15px;
//     width: 25%;
//     overflow-y: auto;
//     max-height: 450px;

//     .close {
//       display: none;
//     }

//     &::-webkit-scrollbar {
//       width: 3px;
//     }

//     &::-webkit-scrollbar-thumb {
//       border-radius: 20px;
//       background: #ff9a22;
//     }

//     .supplier-img {
//       width: 90%;
//       padding-top: 90%;
//       border-radius: 50%;
//       background-repeat: no-repeat;
//       background-position: center;
//       background-size: cover;
//       margin-bottom: 15px;
//     }
//   }
// }

// @media (min-width: 320px) {
//   .cursor-pointer {
//     display: inline;
//   }
// }

// @media (max-width: 425px) {
//   .image-details {
//     padding-left: 0px;
//   }
// }

// @media (max-width: 768px) {
//   .product-info {
//     padding: 0 !important;
//   }
//   .rel-prod {
//     width: 100%;
//     margin-bottom: 15px;

//     img {
//       width: 100%;
//     }
//   }

//   .top-bar {
//     left: 15px;
//     bottom: 15px;

//     .btns {
//       width: auto;
//     }
//   }

//   .supplier-container {
//     top: auto;
//     left: auto;
//     transform: none;
//     z-index: 2;

//     .supplier-box {
//       width: 60px;
//       height: 60px;
//       border-radius: 50%;
//       overflow: hidden;
//       top: auto;
//       left: auto;
//       cursor: pointer;
//       bottom: 15px;
//       right: 15px;
//       transition: width 0.3s, height 0.3s, left 0.3s, top 0.3s;

//       .close {
//         display: block;
//         position: absolute;
//         right: 15px;
//         top: 15px;
//       }

//       .supplier-img {
//         position: absolute;
//         width: 100%;
//         height: 100%;
//         top: 0;
//       }

//       &.open {
//         width: 80%;
//         border-radius: 5px;
//         height: calc(100% - 140px);
//         overflow: scroll;
//         left: 50%;
//         transform: translate(-50%, -50%);
//         top: 50%;

//         .supplier-img {
//           position: unset;
//           width: 90%;
//           padding-top: 90%;
//           height: auto;
//           top: unset;
//         }
//       }
//     }
//   }
// }
</style>
